module.exports = "<div class=\"js-dropdown-region editor editor_dropdown\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/dropdownEditor.hbs
// module id = 685
// module chunks = 0